<template>
  <div
    class="login_box"
    :style="{
      height: loginHeight,
      overflow: 'hidden',
      backgroundPositionY: PCshow ? '-150px' : '',
    }"
  >
    <div class="loginHeader" style="display: flex;">
      <img
        @click="!isIndivAuth && push()"
        :style="{
          marginLeft: PCshow ? '350px' : 'auto',
          marginTop: '8px',
          height: '37px',
          marginRight: PCshow ? '' : 'auto',
          cursor: isIndivAuth ? 'default' : 'pointer',
        }"
        src="../../assets/newLogo-white.png"
        alt=""
      />
      <span
        v-if="PCshow"
        style="font-size: 18ox;color: #3A4260;border-left: 1px solid #DBDDE3;padding-left: 15px;margin-left: 10px;height: 20px;margin-top: 18px;line-height: 21px;"
        >{{ activeName == 'login' ? '登录' : '注册' }}</span
      >
    </div>

    <div class="msg1" style="background: none;margin-top: 30px;" v-if="PCshow">
      <div class="banner" style="padding-left: 356px;">
        <h2 style="font-size: 36px;">杰宜斯云，用心为您服务</h2>
        <p style="font-size: 16px;">
          提供杰宜斯金融软件终端产品帮助中心、多账户金融终端、交易分析评估等增值服务，
          <br />
          实现期货投资业务的深度支持，致力于为客户打造一个开放、贴身的金融服务云环境。
        </p>

        <div style="display: flex;">
          <div style="margin-right: 50px;">
            <span style="width: 130px;font-size: 12px;white-space: nowrap;"
              >扫描进入云服务小程序</span
            >
            <li style="padding: 5px;background-color: #fff;">
              <img
                style="width: 130px;height: 130px;"
                src="../../assets/images/xiaochengxu.png"
                alt=""
              />
            </li>
          </div>
          <!-- <div style="margin-right: 50px;">
            <span>扫码关注公众号</span>
            <li style="padding: 5px;background-color: #fff;">
              <img
                style="width: 120px;"
                src="https://yunsrvwebapi.jeesit.com/img/cloud.png"
                alt=""
              />
            </li>
          </div> -->
          <div>
            <span style="font-size: 12px;">技术认证</span>
            <img
              style="width: 123px;height: 54px;border: 0;"
              src="../../assets/images/huawei.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="register right-tabbox-newnotice" :style="{ right: loginRight }">
      <el-tabs v-model="activeName" @tab-click="handleClick" stretch-true>
        <el-tab-pane label="注册" name="register">
          <!-- 手机号 -->
          <div class="inp_box">
            <input
              v-if="!setPwd"
              autocomplete="off"
              @blur="phoneBlur"
              :style="{
                width: '400px',
                height: '46px',
                borderRadius: '2px',
                marginTop: '45px',
                paddingLeft: '64px',
                border: phoneMode ? '1px solid #fb4044' : '1px solid #e7eaee',
                marginLeft: '40px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }"
              v-model="phone"
              placeholder="手机号"
            />
            <img
              style="width: 11px;height: 16px;"
              src="../../assets/images/login/sj.png"
              alt=""
            />
            <!-- 手机号验证 -->
            <div
              v-show="phoneMode"
              :style="{
                width: '400px',
                margin: '10px auto 0',
                fontSize: '14px',
                color: '#fb4044',
                position: 'absolute',
                bottom: '-30px',
                left: '40px',
              }"
            >
              {{ phone_msg }}
            </div>
          </div>
          <div class="inp_box">
            <input
              v-if="setPwd"
              autocomplete="off"
              :style="{
                width: '400px',
                height: '46px',
                borderRadius: '2px',
                marginTop: '45px',
                paddingLeft: '64px',
                border: '1px solid #e7eaee',
                marginLeft: '40px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }"
              v-model="userName"
              placeholder="设置昵称"
            />
            <img
                v-if="setPwd"
                style="width: 15px;height: 15px;"
                src="../../assets/images/crm/tx1.jpg"
                alt=""
              />
          </div>
          <div class="inp_box">
            <input
              type="password"
              autocomplete="new-password"
              v-if="setPwd"
              :style="{
                width: '400px',
                height: '46px',
                borderRadius: '2px',
                marginTop: '36px',
                paddingLeft: '64px',
                border: '1px solid #e7eaee',
                marginLeft: '40px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }"
              v-model="loginPwd"
              placeholder="设置密码（6~18位组合密码）"
            />
          </div>
          <!-- 图形验证码 -->
          <div v-if="!setPwd" :style="{ position: 'relative' }">
            <div class="inp_box">
              <input
                autocomplete="off"
                :style="{
                  width: '400px',
                  height: '46px',
                  borderRadius: '2px',
                  marginTop: '36px',
                  paddingLeft: '64px',
                  border: '1px solid #e7eaee',
                  marginLeft: '40px',
                  fontSize: '14px',
                  boxSizing: 'border-box',
                }"
                v-model="imgCode"
                placeholder=" 请输入图形验证码"
              />
              <img
                style="width: 13px;height: 15px;"
                src="../../assets/images/login/yzm.png"
                alt=""
              />
              <p
                v-show="code_msg"
                style="width: 400px;
            font-size: 14px;
            color: #fb4044;
            position: absolute;
            bottom: -30px;left: 40px;"
              >
                验证码错误
              </p>
            </div>

            <p
              @click="refreshCode"
              :style="{
                position: 'absolute',
                top: '37px',
                right: '41px',
                width: '100px',
                height: '36px',
                lineHeight: '36px',
              }"
            >
              <Sidentify :identifyCode="identifyCode"> </Sidentify>
            </p>
          </div>
          <!-- 短信验证码 -->
          <div :style="{ position: 'relative' }">
            <div class="inp_box">
              <input
                v-if="!setPwd"
                autocomplete="off"
                :style="{
                  width: '400px',
                  height: '46px',
                  borderRadius: '2px',
                  marginTop: '36px',
                  paddingLeft: '64px',
                  border: '1px solid #e7eaee',
                  marginLeft: '40px',
                  fontSize: '14px',
                  boxSizing: 'border-box',
                }"
                v-model="msgCode"
                placeholder="请输入短信验证码"
              />
              <img
                style="width: 12px;height: 16px;"
                src="../../assets/images/login/dx.png"
                alt=""
              />
            </div>
            <p
              v-if="!setPwd"
              :style="{
                position: 'absolute',
                top: '36px',
                right: '50px',
                width: '100px',
                height: '46px',
                lineHeight: '46px',
                fontSize: '14px',
                color: '#5B85FF',
              }"
            >
              <a
                v-if="msgcode"
                t
                @click="p_code"
                href="javascript:;"
                :style="{ color: '#4184e1' }"
                >获取短信验证码</a
              >
              <a
                v-if="!msgcode"
                href="javascript:;"
                :style="{ color: '#4184e1' }"
                >重新发送({{ count }})</a
              >
            </p>
            <p
              style="width: 400px;
          font-size: 14px;
          color: #fb4044;
          position: absolute;
          bottom: -30px;left: 40px;"
              class="register_err"
              v-show="code_show"
            >
              {{ code_err }}
            </p>
          </div>

          <!-- 注册按钮 -->
          <div
            v-if="!setPwd"
            :style="{
              position: 'relative',
              width: '400px',
              margin: '40px auto 0',
            }"
          >
            <a
              @click="register_btn"
              href="javascript:;"
              :style="{
                display: 'block',
                width: '100%',
                hieght: '46px',
                textAlign: 'center',
                lineHeight: '46px',
                background: '#5B85FF',
                color: '#fff',
                fontSize: '16px',
              }"
            >
              注&nbsp;&nbsp;册
            </a>
            <p
              v-show="agreement_tip_show"
              :style="{
                position: 'absolute',
                top: '100%',
                left: 0,
                width: '100%',
                margin: 0,
                paddingTop: '0px',
                fontSize: '14px',
                color: '#fb4044',
                textAlign: 'center',
                lineHeight: '20px',
              }"
            >
              请阅读并同意《服务协议》和《隐私条款》
            </p>
          </div>
          <a
            v-if="setPwd"
            @click="setOk"
            href="javascript:;"
            :style="{
              display: 'block',
              width: '400px',
              hieght: '46px',
              margin: '40px auto 11px',
              textAlign: 'center',
              lineHeight: '46px',
              background: '#5B85FF',
              color: '#fff',
              fontSize: '16px',
            }"
          >
            完&nbsp;&nbsp;成
          </a>
          <!-- 协议 -->
          <p v-if="!setPwd" class="register-agreement">
            <label class="register-agreement-label">
              <input
                type="checkbox"
                class="register-agreement-checkbox"
                v-model="agreement_ok"
                @change="onAgreementChange"
              />
              <span>我已阅读并同意杰宜斯云</span>
            </label>
            <a
              href="javascript:;"
              class="register-agreement-link"
              @click.prevent="openAgreement('first')"
              >《服务协议》</a
            >
            <span class="register-agreement-text">和</span>
            <a
              href="javascript:;"
              class="register-agreement-link"
              @click.prevent="openAgreement('second')"
              >《隐私条款》</a
            >
          </p>
          <!-- <div v-if=!setPwd :style="{
              width: '400px',
              margin: '0 auto',
              height: '20px',
              textAlign: 'center',
              fontSize: '14px',
              color: '#8997ab',
            }">
            <span :style="{
                display: 'inline-block',
                width: '170px',
                float: 'left',
                color: '#eee',
                fontWeight: '600',
              }">—————————</span>
            微信注册
            <span :style="{
                display: 'inline-block',
                width: '170px',
                float: 'right',
                color: '#eee',
                fontWeight: '600',
              }">—————————</span>
          </div>

          <div v-if=!setPwd :style="{
              width: '356px',
              margin: '30px auto 0',
              height: '50px',
              textAlign:'center'
              
             
            }">
            <img src="../../assets/images/wx.png"  @click.stop.prevent='wxcode_show = true' @click="getQRCode_q()"
             ></img>
          </div> -->
        </el-tab-pane>

        <el-tab-pane disabled=""></el-tab-pane>
        <el-tab-pane disabled=""></el-tab-pane>
        <!-- 登录 -->
        <el-tab-pane label="登录" name="login">
          <!-- 手机号 -->
          <div class="inp_box">
            <input
              autocomplete="off"
              @blur="phoneBlur1"
              :style="{
                width: '400px',
                height: '46px',
                borderRadius: '2px',
                marginTop: '45px',
                paddingLeft: '64px',
                border: phoneMode1 ? '1px solid #fb4044' : '1px solid #e7eaee',
                marginLeft: '40px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }"
              v-model="phone1"
              placeholder="手机号"
            />
            <img
              style="width: 11px;height: 16px;"
              src="../../assets/images/login/sj.png"
              alt=""
            />
            <!-- 手机号验证 -->
            <div
              v-show="phoneMode1"
              :style="{
                width: '400px',
                margin: '10px auto 0',
                fontSize: '14px',
                color: '#fb4044',
                position: 'absolute',
                bottom: '-40px',
                left: '40px',
              }"
            >
              请输入有效的手机号
            </div>
          </div>

          <!-- 短信验证码 -->
          <div v-show="mode" :style="{ position: 'relative' }">
            <div class="inp_box">
              <input
                autocomplete="off"
                :style="{
                  width: '400px',
                  height: '46px',
                  borderRadius: '2px',
                  marginTop: '54px',
                  paddingLeft: '64px',
                  border: '1px solid #e7eaee',
                  marginLeft: '40px',
                  fontSize: '14px',
                  boxSizing: 'border-box',
                }"
                v-model="msgCode1"
                placeholder="请输入短信验证码"
              />
              <img
                style="width: 12px;height: 16px;"
                src="../../assets/images/login/dx.png"
                alt=""
              />
            </div>
            <p
              :style="{
                position: 'absolute',
                top: '54px',
                right: '60px',
                width: '100px',
                height: '46px',
                lineHeight: '46px',
                fontSize: '14px',
                color: '#5B85FF',
              }"
            >
              <a
                v-show="msgcode1"
                href="javascript:;"
                @click="p_code1"
                :style="{ color: '#5B85FF' }"
              >
                获取短信验证码</a
              >
              <a
                v-if="!msgcode1"
                href="javascript:;"
                :style="{ color: '#5B85FF' }"
                >重新发送({{ count1 }})</a
              >
            </p>
          </div>
          <!-- 密码 -->
          <div class="inp_box">
            <input
              autocomplete="new-password"
              @focus="pwd_focus"
              v-show="!mode"
              :style="{
                width: '400px',
                height: '46px',
                borderRadius: '2px',
                marginTop: '54px',
                paddingLeft: '64px',
                border: '1px solid #e7eaee',
                marginLeft: '40px',
                fontSize: '14px',
                boxSizing: 'border-box',
              }"
              type="password"
              v-model="pwd"
              placeholder="请输入密码"
            />
            <img
              style="width: 12px;height: 16px;"
              src="../../assets/images/login/mm.png"
              alt=""
            />
            <p
              style="font-size:14px;position: absolute;bottom: -30px;left: 40px;"
              class="login_err"
              v-show="login_show"
            >
              {{ login_e }}
            </p>
          </div>

          <!-- 登录按钮 -->
          <a
            @click="login"
            href="javascript:;"
            :style="{
              display: 'block',
              width: '400px',
              hieght: '46px',
              margin: '54px auto 15px',
              textAlign: 'center',
              lineHeight: '46px',
              background: '#5B85FF',
              color: '#fff',
              fontSize: '16px',
            }"
          >
            登&nbsp;&nbsp;录
          </a>
          <!-- 登录方式 -->
          <div
            v-if="!mode"
            :style="{
              width: '400px',
              margin: '0 auto 20px',
              display: 'flex',
              height: '45px',
            }"
          >
            <a
              href="#"
              :style="{
                flex: 1,
                textAlign: 'left',
                color: '#5B85FF',
                fontSize: '14px',
                height: '45px',
                lineHeight: '45px',
              }"
              @click="mode = true"
              >使用手机验证码登录</a
            >
            <a
              :style="{
                flex: 1,
                textAlign: 'right',

                fontSize: '14px',
                height: '45px',
                lineHeight: '45px',
              }"
            >
              <router-link
                :style="{ color: '#F54836', fontSize: '14px' }"
                :to="{ path: '/login/forgetpwd', query: $route.query }"
              >
                忘记密码?
              </router-link>
            </a>
          </div>
          <div
            v-if="mode"
            :style="{
              width: '400px',
              margin: '0 auto 20px',
              display: 'flex',
              height: '45px',
            }"
          >
            <a
              href="#"
              :style="{
                flex: 1,
                textAlign: 'left',
                color: '#5B85FF',
                fontSize: '14px',
                height: '45px',
                lineHeight: '45px',
              }"
              @click="mode = false"
              >使用账号密码</a
            ><a
              href="javascript:;"
              :style="{
                flex: 1,
                textAlign: 'right',

                fontSize: '14px',
                height: '45px',
                lineHeight: '45px',
              }"
            >
              <router-link
                :style="{ color: '#F54836' }"
                :to="{ path: '/login/forgetpwd', query: $route.query }"
              >
                忘记密码?
              </router-link>
            </a>
          </div>

          <!-- 微信登录 -->
          <!-- <div :style="{
              width: '400px',
              margin: '0 auto',
              height: '20px',
              textAlign: 'center',
              fontSize: '14px',
              color: '#8997ab',
            }">
            <span :style="{
                display: 'inline-block',
                width: '170px',
                float: 'left',
                color: '#eee',
                fontWeight: '600',
              }">—————————</span>
            微信登录
            <span :style="{
                display: 'inline-block',
                width: '170px',
                float: 'right',
                color: '#eee',
                fontWeight: '600',
              }">—————————</span>
          </div> -->

          <!-- <div :style="{
              width: '356px',
              margin: '30px auto 0',
              height: '50px',
              textAlign: 'center',
          
           
            }">
            <img src="../../assets/images/wx.png"  @click.stop.prevent='wxcode_show = true' @click="getQRCode_q()"
             ></img>
          </div> -->
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync="agreement" width="800" center>
      <el-tabs v-model="activeName1" type="card">
        <el-tab-pane label="服务协议" name="first">
          <p>
            <b>【首部及导言】</b><br /><br />
            欢迎您使用杰宜斯云服务！<br /><br />
            &emsp;&emsp;
            <b>
              为使用杰宜斯云的服务，您应当阅读并遵守《杰宜斯云服务协议》（以下简称“本协议”）和《杰宜斯云隐私政策》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制杰宜斯云责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款等，以及开通或使用某项服务的单独协议或规则。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点注意。<br /><br />
              &emsp;&emsp;除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权使用杰宜斯云服务。您点击“同意”或“下一步”，或您使用杰宜斯云服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与杰宜斯云之间产生法律效力，成为对双方均具有约束力的法律文件。<br /><br />
              &emsp;&emsp;如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。<br /><br />
              &emsp;&emsp;如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。</b
            >
            <br /><br />
            &emsp;&emsp;<span
              style="color: #fb4044;text-decoration: underline;"
            >
              <b
                >如果您不同意《云服务协议》《云服务隐私条款》中的任何条款，您应立即终止访问或使用。</b
              > </span
            ><br /><br />

            <b>一、【协议的范围】</b> <br /><br />
            &emsp;&emsp;
            1.1本协议是用户与杰宜斯云之间关于其使用杰宜斯云服务所订立的协议。
            “用户”是指杰宜斯云的服务的使用人，在本协议中更多地称为“您”。<br /><br />
            &emsp;&emsp;
            1.2杰宜斯云的服务是指杰宜斯云向用户提供的，包括但不限于帐号管理、模拟帐号申请、终端下载、CRM、外部数据导入分析等产品及服务，具体服务以杰宜斯云实际提供的为准（以下简称“本服务”）。<br /><br />
            &emsp;&emsp;
            <b>
              1.3本协议内容同时包括《杰宜斯云隐私政策》,且您在使用杰宜斯云某一特定服务时，该服务可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何单独协议的接受，即视为您对本协议全部的接受。您对本协议的接受，即视为您对《杰宜斯云隐私政策》的接受。</b
            ><br /><br />
            <b>二、【帐号与密码安全】</b><br /><br />
            &emsp;&emsp;2.1您在使用本服务时可能需要注册一个帐号。关于您使用帐号的具体规则，请仔细阅读并遵守相关单独协议。<br /><br />
            &emsp;&emsp;2.2杰宜斯云特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受被盗号或密码失窃，责任由您自行承担。<br /><br />
            &emsp;&emsp;2.3您在使用本服务过程中，可能可以为您使用的帐号设置昵称、头像、签名、留言等信息，也可能为您建立或者管理、参与的企业、团队等设置名称、图片、简介等信息。您应当保证这些信息的内容和形式符合法律法规（本协议中的“法律法规”指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等，下同。）、公序良俗、社会公德以及杰宜斯云平台规则，且不会侵害任何主体的合法权益。<br /><br />
            <b> 三、【用户个人信息保护】</b><br /><br />
            &emsp;&emsp;
            <b>
              3.1保护用户个人信息是杰宜斯云的一项基本原则。杰宜斯云将按照本协议及《杰宜斯云隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《杰宜斯云隐私政策》的内容为准。</b
            >
            <br /><br />
            &emsp;&emsp;3.2您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则可能无法使用本服务或在使用过程中受到限制。<br /><br />
            &emsp;&emsp;3.3一般情况下，您可根据相关产品规则浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务等）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。<br /><br />
            &emsp;&emsp;3.4杰宜斯云将尽可能运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。<br /><br />
            &emsp;&emsp;<b>
              3.5杰宜斯云不会将您的个人信息转移或披露给任何第三方，除非：<br /><br />
              &nbsp;&emsp;&emsp;（1）相关法律法规或司法机关、行政机关要求。<br /><br />
              &nbsp;&emsp;&emsp;（2）为完成合并、分立、收购或资产转让而转移。<br /><br />
              &nbsp;&emsp;&emsp;（3）为提供您要求的服务所必需。<br /><br />
              &nbsp;&emsp;&emsp;（4）依据《杰宜斯云隐私政策》或其他相关协议规则可以转移或披露给任何第三方的情形。<br /><br
            /></b>
            &emsp;&emsp;3.6杰宜斯云非常重视对未成年人个人信息的保护。若您不具备完全民事行为能力，在使用杰宜斯云服务前，应事先取得您的监护人的同意。<br /><br />

            <b>四、【使用本服务的方式】</b><br /><br />
            &emsp;&emsp;4.1本服务仅为您个人非商业性质的使用，除非您与杰宜斯云另有约定。<br /><br />
            &emsp;&emsp;4.2您依本协议条款所取得的权利不可转让。<br /><br />
            &emsp;&emsp;4.3您不得使用任何方式（包括但不限于第三方软件、插件、外挂、系统、设备等）对本服务进行干扰、破坏、修改或施加其他影响。<br /><br />
            &emsp;&emsp;4.4您应当通过杰宜斯云提供或认可的方式使用本服务，不得通过任何第三方软件、插件、外挂、系统、设备等登录或使用本服务。<br /><br />
            &emsp;&emsp;4.5任何人未经杰宜斯云授权不得使用任何第三方软件、插件、外挂、系统等查看、获取本服务中所包含的杰宜斯云或用户的任何相关信息、数据等内容，同时，应当严格遵守杰宜斯云发布的Robots协议等相关协议规则<br /><br />
            <b>
              五、【按现状提供服务】<br /><br />
              您理解并同意：<br /><br />
              &emsp;&emsp;5.1本服务是按照现有技术和条件所能达到的现状提供的。杰宜斯云会尽最大努力保障服务的连贯性和安全性，但杰宜斯云不能随时预见和防范法律、技术以及其他风险，杰宜斯云对此类风险在法律允许的范围内免责，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。<br /><br />
              &emsp;&emsp;5.2因经营策略安排或调整等原因,不同地区的用户可使用的具体杰宜斯云服务的内容可能会存在差异，具体以杰宜斯云实际提供的为准。<br /><br />
            </b>

            <b>六、【自备设备】</b><br /><br />
            &emsp;&emsp;6.1您应当理解，您使用本服务需自行准备与相关服务有关的终端设备（如电脑、移动终端和必要的网络接入设备等装置），并承担所需的费用（如电话费、上网费等费用）。<br /><br />
            &emsp;&emsp;6.2您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。<br /><br />

            <b>七、【服务费用】</b> <br /><br />
            &emsp;&emsp;7.1杰宜斯云的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。<br /><br />
            &emsp;&emsp;7.2杰宜斯云可能根据实际需要对收费服务的收费标准、方式进行修改和变更，杰宜斯云也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，杰宜斯云将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。<br /><br />
            &emsp;&emsp;7.3在杰宜斯云降低收费服务的收费标准或者将收费服务改为免费服务提供时，杰宜斯云保留不对原付费用户提供退费或者费用调整之权利。<br /><br />

            <b> 八、【基于软件提供服务】</b><br /><br />
            若杰宜斯云依托“软件”向您提供服务，您还应遵守以下约定：<br /><br />
            &emsp;&emsp;8.1您在使用本服务的过程中可能需要下载软件，对于这些软件，杰宜斯云给予您一项个人的、不可转让及非排他性的许可。您仅可为使用本服务的目的而使用这些软件。<br /><br />
            &emsp;&emsp;8.2为了改善用户体验、保障服务的安全性及产品功能的一致性等目的，杰宜斯云可能会对软件进行更新。您应该将相关软件更新到最新版本，否则杰宜斯云并不保证软件或服务能正常使用。<br /><br />
            &emsp;&emsp;8.3杰宜斯云可能为不同的终端设备开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。您可以直接从杰宜斯云平台上获取软件。如果您从第三方获取软件或与软件名称相同的安装程序，杰宜斯云无法保证该软件或服务能够正常使用，并对因此给您造成的损失不予负责。<br /><br />
            &emsp;&emsp;
            <b> 8.4除非杰宜斯云书面许可，您不得从事下列任一行为：</b
            ><br /><br />
            &nbsp;&emsp;&emsp;（1）删除软件及其副本上关于著作权的信息。<br /><br />
            &nbsp;&emsp;&emsp;（2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码。<br /><br />
            &nbsp;&emsp;&emsp;（3）对杰宜斯云拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等。<br /><br />
            &nbsp;&emsp;&emsp;（4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经杰宜斯云授权的第三方工具/服务接入软件和相关系统。<br /><br />
            &nbsp;&emsp;&emsp;（5）通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的。<br /><br />
            &nbsp;&emsp;&emsp;（6）通过非杰宜斯云开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用杰宜斯云软件及服务，或制作、发布、传播非杰宜斯云开发、授权的用于登录或使用杰宜斯云软件及服务的第三方软件、插件、外挂、系统、设备等。<br /><br />

            <b> 九、【知识产权声明】</b><br /><br />
            &emsp;&emsp;9.1杰宜斯云在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归杰宜斯云所有，用户在使用本服务中所产生内容的知识产权归用户或相关权利人所有，除非您与杰宜斯云另有约定。<br /><br />
            &emsp;&emsp;9.2除另有特别声明外，杰宜斯云提供本服务时所依托软件的著作权、专利权及其他知识产权均归杰宜斯云所有。<br /><br />
            &emsp;&emsp;9.3杰宜斯云在本服务中所使用的“杰宜斯云”商业标识，其著作权或商标权归杰宜斯所有。<br /><br />
            &emsp;&emsp;9.4上述及其他任何本服务包含的内容的知识产权均受到法律法规保护，未经杰宜斯云、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。<br /><br />

            <b> 十、【用户违法违规行为】</b><br /><br />
            &emsp;&emsp; 10.1您在使用本服务时须遵守法律法规，不得制作、复制、发布、传播含有下列内容的信息或从事相关行为，也不得为制作、复制、发布、传播含有下列内容的信息或从事相关行为提供便利：<br /><br />
            &nbsp;&emsp;&emsp;（1）反对宪法所确定的基本原则的。<br /><br />
            &nbsp;&emsp;&emsp;（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。<br /><br />
            &nbsp;&emsp;&emsp;（3）损害国家荣誉和利益的。<br /><br />
            &nbsp;&emsp;&emsp;（4）煽动民族仇恨、民族歧视，破坏民族团结的。<br /><br />
            &nbsp;&emsp;&emsp;（5）破坏国家宗教政策，宣扬邪教和封建迷信的。<br /><br />
            &nbsp;&emsp;&emsp;（6）散布谣言，扰乱社会秩序，破坏社会稳定的。<br /><br />
            &nbsp;&emsp;&emsp;（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的。<br /><br />
            &nbsp;&emsp;&emsp;（8）侮辱或者诽谤他人，侵害他人合法权益的。<br /><br />
            &nbsp;&emsp;&emsp;（9）违反法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的。<br /><br />
            &nbsp;&emsp;&emsp;（10）相关法律法规或本协议、相关协议、规则等禁止的。<br /><br />
            &emsp;&emsp;10.2如果您在使用本服务过程中违反了相关法律法规或本协议约定，相关国家机关或合作方可能会对您提起诉讼、罚款或采取其他制裁措施，并要求杰宜斯云给予协助。因此给您或者他人造成损害的，您应自行承担全部责任，杰宜斯云不承担任何责任。<br /><br />
            &emsp;&emsp;<b>
              10.3如果您违反本协议约定，杰宜斯云有权进行独立判断并采取相应措施，包括但不限于通过技术手段删除、屏蔽相关内容或断开链接等。同时，杰宜斯云有权视用户的行为性质，采取包括但不限于暂停或终止向您提供服务，限制、中止、冻结或终止您对杰宜斯云帐号的使用，追究法律责任等措施。</b
            ><br /><br />
            &emsp;&emsp;10.4您违反本协议约定，导致任何主体损失的，您应当独立承担责任；杰宜斯云因此遭受损失的，您也应当一并赔偿。<br /><br />

            <b> 十一、【遵守当地法律监管】</b><br /><br />
            &emsp;&emsp;11.1您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。<b
              >如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。</b
            >
            <br /><br />
            &emsp;&emsp;<b
              >11.2您应避免因使用本服务而使杰宜斯云违反法律法规或卷入政治和公共事件，否则杰宜斯云有权暂停或终止对您的服务。</b
            ><br /><br />

            <b>
              十二、【用户发送、传播的内容与投诉处理】<br /><br />
              &emsp;&emsp;12.1您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。<br /><br />
              &emsp;&emsp;12.2您发送或传播的内容应有合法来源，相关内容为您所有或您已获得必要的授权。<br /><br />
              &emsp;&emsp;12.3如果您发送或传播的内容违法违规或侵犯他人权利的，杰宜斯云有权进行独立判断并采取删除、屏蔽或断开链接等措施。<br /><br />
              &emsp;&emsp;12.4如您被他人投诉或您投诉他人，杰宜斯云有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。<br /><br />
              &emsp;&emsp;12.5您保证对您在投诉处理程序中提供的信息、材料、证据等的真实性、合法性、有效性负责。</b
            ><br /><br />
            <b>
              十三、【不可抗力及其他免责事由】<br /><br />
              &emsp;&emsp;13.1您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，杰宜斯云将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失杰宜斯云在法律允许的范围内免责。<br /><br />
              &emsp;&emsp;13.2在法律允许的范围内，杰宜斯云对以下情形导致的服务中断或受阻不承担责任：<br /><br />
              &nbsp;&emsp;&emsp;（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏。<br /><br />
              &nbsp;&emsp;&emsp;（2）用户或杰宜斯云的电脑软件、系统、硬件和通信线路出现故障。<br /><br />
              &nbsp;&emsp;&emsp;（3）用户操作不当或用户通过非杰宜斯云授权的方式使用本服务。<br /><br />
              &nbsp;&emsp;&emsp;（4）程序版本过时、设备的老化和/或其兼容性问题。<br /><br />
              &nbsp;&emsp;&emsp;（5）其他杰宜斯云无法控制或合理预见的情形。<br /><br />
              &emsp;&emsp; 13.3您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，杰宜斯云不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：<br /><br />
              &nbsp;&emsp;&emsp;（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息。<br /><br />
              &nbsp;&emsp;&emsp;（2）遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失。<br /><br />
              &nbsp;&emsp;&emsp;（3）其他因网络信息或用户行为引起的风险。<br /><br />
              &emsp;&emsp; 13.4杰宜斯云依据本协议约定获得处理违法违规内容的权利，该权利不构成杰宜斯云的义务或承诺，杰宜斯云不能保证及时发现违法行为或进行相应处理。<br /><br />
              &emsp;&emsp;13.5在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。涉及财产操作的，请一定先核实对方身份，并请经常留意杰宜斯云有关防范诈骗犯罪的提示。<br /><br />
            </b>
            <b>
              十四、【协议的生效与变更】<br /><br />
              &emsp;&emsp;14.1您使用本服务即视为您已阅读本协议并接受本协议的约束。<br /><br />
              &emsp;&emsp;14.2杰宜斯云有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。<br /><br />
              &emsp;&emsp;14.3本协议条款变更后，如果您继续使用杰宜斯云提供的软件或服务，即视为您已接受变更后的协议。<br /><br />
            </b>
            <b> 十五、【服务的变更、中断、终止】</b><br /><br />
            &emsp;&emsp;<b>
              15.1您理解并同意，杰宜斯云基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。<br /><br />
              &emsp;&emsp; 15.2在杰宜斯云发生合并、分立、收购、资产转让时，杰宜斯云可向第三方转让本服务下相关资产；杰宜斯云也可在单方通知您后，将本协议下部分或全部服务及相应的权利义务转交由第三方运营或履行。具体受让主体以杰宜斯云通知的为准。<br /><br />
              &emsp;&emsp;15.3如发生下列任何一种情形，杰宜斯云有权不经通知而中断或终止向您提供服务：<br /><br />
              &nbsp;&emsp;&emsp;（1）根据法律法规规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明。<br /><br />
              &nbsp;&emsp;&emsp;（2）您违反相关法律法规的规定或违反本协议的约定。<br /><br />
              &nbsp;&emsp;&emsp;（3）按照法律法规规定，司法机关或主管部门的要求。<br /><br />
              &nbsp;&emsp;&emsp;（4）出于安全的原因或其他必要的情形。</b
            ><br /><br />
            &emsp;&emsp; 15.4杰宜斯云有权按本协议7.2条的约定进行收费。若您未按时足额付费，杰宜斯云有权中断、中止或终止提供服务。<br /><br />
            &emsp;&emsp; 15.5您有责任自行备份存储在本服务中的数据。如果您的服务被终止，杰宜斯云有权从服务器上永久地删除您的数据,法律法规另有规定的除外。服务中止或终止后，杰宜斯云没有义务向您提供或返还数据。<br /><br />

            <b> 十六、【管辖与法律适用】</b> <br /><br />
            &emsp;&emsp;<b>
              16.1本协议的成立、生效、履行、解释及纠纷解决等相关事宜，均适用中华人民共和国大陆地区法律（不包括冲突法）。<br /><br />
              &emsp;&emsp;16.2本协议签订地为中华人民共和国湖北省武汉市武昌区。<br /><br />
              &emsp;&emsp;16.3若您和杰宜斯云之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地（即中国湖北省武汉市武昌区）有管辖权的人民法院管辖。</b
            ><br /><br />
            &emsp;&emsp;16.4本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。<br /><br />
            &emsp;&emsp;16.5本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。<br /><br />
            &emsp;&emsp;16.6若本协议有中文、英文等多个语言版本，相应内容不一致的，均以中文版的内容为准。<br /><br />
          </p>
          <b> 十七、【其他】</b> <br /><br />
          &emsp;&emsp;17.1如果您对本协议或本服务有意见或建议，可与杰宜斯云客户服务部门联系，我们会给予您必要的帮助。（正文完）<br /><br /><br /><br />

          杰宜斯
        </el-tab-pane>
        <el-tab-pane label="隐私条款" name="second">
          <p>
            <b>隐私条款</b><br /><br />

            &emsp;&emsp;杰宜斯云服务非常重视对您的个人隐私保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私政策解释了这些情况下的数据收集和使用情况。<br /><br />
            &emsp;&emsp;本政策适用于杰宜斯云服务的所有相关服务，随着杰宜斯云服务服务范围的扩大，隐私政策的内容可由杰宜斯云服务随时更新，且毋须另行通知。更新后的隐私政策一旦在网页上公布即有效代替原来的隐私政策。<br /><br />
            <b>我们收集哪些信息</b><br /><br />
            &emsp;&emsp;通常，您能在匿名的状态下访问杰宜斯云服务获取信息。当我们需要能识别您的个人信息或者可以与您联系的信息时，我们会征求您的同意。<br /><br />
            &emsp;&emsp;通常，在您注册杰宜斯云服务或申请开通新的功能时，您至少需要向我们提供您准备使用的账户名、密码，我们可能收集您的：姓名、手机号、邮箱、头像图片等，并征求您的确认。这些信息均属于您的“账户信息”。<br /><br />
            <b>关于您的个人信息</b><br /><br />
            &emsp;&emsp;杰宜斯云服务严格保护您个人信息的安全。<br /><br />
            &emsp;&emsp;我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。<br /><br />
            &emsp;&emsp;杰宜斯云服务会在法律要求或符合杰宜斯云服务的相关服务条款、软件许可使用协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：<br /><br />
            &emsp;&emsp;&emsp;&emsp;(a)满足法律或行政法规的明文规定，或者符合杰宜斯云服务适用的法律程序；<br /><br />
            &emsp;&emsp;&emsp;&emsp;(b)符合杰宜斯云服务相关服务条款、软件许可使用协议的约定；<br /><br />
            &emsp;&emsp;&emsp;&emsp;(c)保护杰宜斯云服务的权利或财产；<br /><br />
            &emsp;&emsp;&emsp;&emsp;(d)在紧急情况下保护杰宜斯云服务员工、杰宜斯云服务产品或服务的用户或大众的个人安全；<br /><br />
            &emsp;&emsp;杰宜斯云服务不会未经您的允许将这些信息与第三方共享，本政策已经列出的上述情况除外。<br /><br />
            <b>Cookie的使用</b><br /><br />
            &emsp;&emsp; 使用 Cookie
            能帮助您实现您的联机体验的个性化，您可以接受或拒绝 Cookie ，大多数
            Web 浏览器会自动接受
            Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。<br /><br />
            &emsp;&emsp;杰宜斯云服务有时会使用 Cookie
            以便知道哪些网站受欢迎，使您在访问杰宜斯云服务时能得到更好的服务。Cookie不会跟踪个人信息。<br /><br />
            &emsp;&emsp;当您注册杰宜斯云服务时，杰宜斯云服务亦会使用
            Cookie。在这种情况下，杰宜斯云服务会收集并存储有用信息，当您再次访问杰宜斯云服务时，我们可辨认您的身份。来自杰宜斯云服务的
            Cookie 只能被杰宜斯云服务读取。<br /><br />
            &emsp;&emsp;如果您的浏览器被设置为拒绝
            Cookie，您仍然能够访问杰宜斯云服务的网页，但是部分功能可能无法正常使用。<br /><br />
          </p>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addagreement">同意</el-button>
      </span>
    </el-dialog>

    <!--  微信二维码 -->
    <!-- <transition name="el-fade-in-linear">
      <div class="wxCode" v-show=wxcode_show @click.stop.prevent='wxcode_show=false'>
        <div class="wxBox">
          <h2>微信登录</h2>
          <div class="code"><canvas id="QRCode_q" /> </div>
          <p>请使用微信二维码登录</p>
        </div>
      </div>
    </transition> -->
    <!-- <wxlogin></wxlogin> -->
    <div class="footer" style="bottom: 30px;padding-top: 15px;" v-if="PCshow">
      <div class="foot" style="height: 130px;">
        <p>
          声明：“杰宜斯云”服务平台系武汉杰宜斯信息科技有限公司（以下称：我司）为客户提供的增值服务平台，<br />
          该平台主要作用有数据分析及展示，我司不会对客户数据进行抓取、存储，不会使用客户数据进行盈利性商业活动，<br />
          我司所有开放行为均会在客户认可、自主的前提下进行，随时接受客户监督。
        </p>
      </div>
      <li class="f_bottom">
        Copyright © 2026 武汉杰宜斯信息科技有限公司<a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          >鄂ICP备14015145号-1</a
        >
      </li>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Sidentify from './sidentify/index';
// import SIdentify from '@/view/login/identify'
import '@/assets/iconfont/iconfont.css';
import './style.css';
import QRCode_q from 'qrcode';
import {
  isIndivAuthFlow,
  stripFromIndivFromHref,
  tabFromQuery,
} from '@/utils/authTabQuery';

export default {
  name: 'register',
  props: ['loginType'],
  components: { Sidentify },
  data() {
    return {
      loginRight: '360px',
      code_msg: false,
      identifyCode: '',
      identifyCodes: 'abcdefghijklmnopqrstuvwxyz123456789',
      wxcode_show: false,
      phone_msg: '',
      agreement_ok: false, //是否同意协议
      agreement_tip_show: false, //未勾选协议提示
      activeName1: 'first',
      agreement: false, //协议显示隐藏
      code_err: '', //注册错误提示
      code_show: false, //控制注册错误提示显示隐藏
      login_e: '', //登录错误提示
      login_show: false, //控制登录错误提示显示隐藏
      mapActions: {},

      activeName: 'login',
      phone: '', //注册的手机号
      phone1: '', //登录得手机号
      imgCode: '',
      msgCode: '',
      msgCode1: '',
      mode: false, //登录方式 false账号密码登录 true 手机验证码登录
      phoneMode: false,
      phoneMode1: false,
      pwd: '',
      msgcode: true, //短信验证码
      msgcode1: true,
      count: 60,
      count1: 60,
      userName: '',
      loginPwd: '',
      setPwd: false,
      QRCode_qMsg: '', // 生成二维码信息
      loginHeight: '',
      PCshow: '',
    };
  },
  computed: {
    isIndivAuth() {
      return isIndivAuthFlow(this.$route.query || {});
    },
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPad|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      console.log('手机');
      this.PCshow = false;
      this.loginRight = '';
      this.loginHeight = document.documentElement.clientHeight + 'px';
    } else {
      console.log('电脑');
      this.loginHeight = document.documentElement.clientHeight - 180 + 'px';
      this.PCshow = true;
      this.loginRight = '360px';
    }
  },
  created() {
    this.refreshCode();
    this.syncTabFromRoute();
    if (this.loginType) {
      this.activeName = this.loginType;
    }
  },

  methods: {
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.login();
      }
    },
    // 图形验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
      // console.log('当前验证码=',this.identifyCode)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    getQRCode_q() {
      //二维码

      this.QRCode_qMsg =
        'https://api.weixin.qq.com/sns/oauth2/access_token?appid=APPID&secret=SECRET&code=CODE&grant_type=authorization_code'; // 生成的二维码为URL地址
    },
    // ...mapActions("modules/account", ["settoken", "setname"]),
    jumpregister: function() {
      this.$router.push({
        path: '/register',
        query: { ...(this.$route.query || {}) },
      });
    },

    addagreement() {
      this.agreement = false;
      this.agreement_ok = true;
      this.agreement_tip_show = false;
      this.code_err = '';
    },
    onAgreementChange() {
      if (this.agreement_ok) {
        this.agreement_tip_show = false;
      }
    },
    openAgreement(tab = 'first') {
      this.activeName1 =
        tab === 'first' || tab === 'second' ? tab : 'first';
      this.agreement = true;
    },
    syncTabFromRoute() {
      if (this.loginType) return;
      this.activeName = tabFromQuery(this.$route.query);
    },
    handleClick(tab) {
      const name = tab.name || this.activeName;
      if (name !== 'login' && name !== 'register') return;

      const query = { ...(this.$route.query || {}) };
      if (!isIndivAuthFlow(query)) return;
      if (name === 'register') {
        query.tab = 'register';
      } else {
        delete query.tab;
      }
      if (query.type === 'login' || query.type === 'register') delete query.type;
      this.$router.replace({ path: '/login', query }).catch(() => {});
    },
    phoneBlur() {
      //注册 手机输入框失去焦点触发验证
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.phoneMode = false;
      } else {
        this.phoneMode = true;
        this.phone_msg = '请输入有效的手机号';
      }
    },
    phoneBlur1() {
      //登录 手机输入框失去焦点触发验证
      if (/^1[3456789]\d{9}$/.test(this.phone1)) {
        this.phoneMode1 = false;
      } else {
        this.phoneMode1 = true;
      }
    },
    pwd_focus() {
      this.login_show = false;
    },
    p_code() {
      //获取手机验证码
      var that = this;
      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        this.phoneMode = false;
        this.$axios({
          method: 'post',
          url: '/user_login_api/sendCode',
          params: {
            type: 'register',
            mob: this.phone,
          },
        }).then((res) => {
          if (res.data.code == 200) {
            that.msgcode = false;
            var Interval = setInterval(function() {
              that.count--;
            }, 1000);

            setTimeout(function() {
              that.msgcode = true;
              clearInterval(Interval);
              that.count = 60;
            }, 60000);
            // console.log(res);
          } else {
            this.phoneMode = true;
            this.phone_msg = res.data.message;
          }
        });
      } else {
        this.phoneMode = true;
        this.phone_msg = '请输入有效的手机号';
      }
    },
    p_code1() {
      //登录手机号
      var that = this;
      if (/^1[3456789]\d{9}$/.test(this.phone1)) {
        this.phoneMode1 = false;
        this.$axios
          .post('/user_login_api/sendCode', { type: 'login', mob: this.phone1 })
          .then((res) => {
            that.msgcode1 = false;
            var Interval = setInterval(function() {
              that.count1--;
            }, 1000);

            setTimeout(function() {
              that.msgcode1 = true;
              clearInterval(Interval);
              that.count1 = 60;
            }, 60000);
            // console.log(res);
          });
      } else {
        this.phoneMode1 = true;
      }
    },
    push() {
      const q = this.$route.query || {};
      if (String(q.from) === 'indiv') {
        this.$router.push({ path: '/', query: { from: 'indiv' } });
      } else {
        this.$router.push('/');
      }
    },
    /** 登录/注册成功：地址栏有 from=indiv 时固定账户列表；否则回 path 或首页且不带 from=indiv */
    postAuthRedirectHref() {
      const q = this.$route.query || {};
      if (String(q.from) === 'indiv') {
        return '/user/eval_jees/list?from=indiv';
      }
      const saved = localStorage.getItem('path');
      if (saved) return stripFromIndivFromHref(saved);
      return '/';
    },

    login() {
      //登录
      if (/^1[3456789]\d{9}$/.test(this.phone1)) {
        if (!this.mode) {
          this.$axios({
            method: 'post',
            url: '/user_login_api/pwdLogin',
            params: {
              phone: this.phone1,
              pwd: this.pwd,
            },
          })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                localStorage.setItem('token', JSON.stringify(res.data.data));
                let date = Date.parse(new Date());
                localStorage.setItem('loginDate', date);
                // console.log(localStorage.getItem("token"))
                // console.log(this.$store.state.api)
                window.location.href = this.postAuthRedirectHref();
              } else {
                this.login_show = true;
                this.login_e = res.data.message;
              }
            })
            .catch((err) => {
              // console.log(err)
            });
        } else {
          this.$axios
            .post('/user_login_api/phoneLogin', {
              phone: this.phone1,
              verifyCode: this.msgCode1,
            })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                localStorage.setItem('token', JSON.stringify(res.data.data));
                // console.log(localStorage.getItem("token"))
                window.location.href = this.postAuthRedirectHref();
              } else {
                this.login_show = true;
                this.login_e = res.data.message;
              }
            })
            .catch((err) => {
              // console.log(err)
            });
        }
      }
    },
    register_btn() {
      //注册
      if (!this.agreement_ok) {
        this.agreement_tip_show = true;
        return;
      }
      this.agreement_tip_show = false;

      if (/^1[3456789]\d{9}$/.test(this.phone)) {
        if (this.imgCode == this.identifyCode) {
          this.code_msg = false;
          if (this.msgCode) {
            this.$axios({
              method: 'post',
              url: '/user_login_api/authphone',
              params: {
                type: 'register',
                mob: this.phone,
                verifyCode: this.msgCode,
              },
            })
              .then((res) => {
                // console.log(res);
                if (res.data.code == 200) {
                  this.setPwd = true;
                } else {
                  this.code_show = true;
                  this.code_err = res.data.message;
                }
              })
              .catch((err) => {
                // console.log(err)
              });
          } else {
            this.code_err = '请输入验证码';
            this.code_show = true;
          }
        } else {
          this.code_msg = true;
        }
      } else {
        this.code_err = '请输入正确的手机号';
        this.code_show = true;
      }
    },
    setOk() {
      //设置个人信息
      this.$axios({
        method: 'post',
        url: '/user_login_api/setPassNikeName',
        params: {
          valideCode: this.msgCode,
          nickName: this.userName,
          pwd: this.loginPwd,
          phone: this.phone,
          registerType: 1,
        },
      }).then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          localStorage.setItem('token', JSON.stringify(res.data.data));
          // this.$router.push('./')

          let date = Date.parse(new Date());
          localStorage.setItem('loginDate', date);
          // console.log(localStorage.getItem("token"))
          // console.log(this.$store.state.api)
          window.location.href = this.postAuthRedirectHref();
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: '确定',

            type: 'warning',
            center: true,
          })
            .then(() => {})
            .catch(() => {});
        }
      });
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.syncTabFromRoute();
      },
      deep: true,
    },
    // 通过监听获取数据
    QRCode_qMsg(val) {
      // 获取页面的canvas
      var msg = document.getElementById('QRCode_q');
      // 将获取到的数据（val）画到msg（canvas）上
      QRCode_q.toCanvas(msg, val, function(error) {
        // console.log(error)
      });
    },
    loginType() {
      // console.log(this.loginType)

      this.activeName = this.loginType;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/register/index.vue